// 基础信息页
import React, { Component } from "react";
import "../../../assets/stylus/com/display/process.styl";
import PropsType from "prop-types";

// 引用的组件
import StubDetailInfo from "./stubDetailInfoNew";

class StubBasicInfo extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.stubId = window.LayoutTab.tabParam.stubId;
      this.isWare = !!window.LayoutTab.tabParam.isWare;
    }
    this.state = {
      stubId: this.stubId,
      isWare: this.isWare,
    };
  }

  componentWillMount() {}

  render() {
    const Content = (
      <div className="sc-page-content">
        <StubDetailInfo isWare={this.state.isWare} stubId={this.state.stubId} />
      </div>
    );
    return Content;
  }
}

export default StubBasicInfo;

StubBasicInfo.propsType = {
  onAdd: PropsType.func,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubBasicInfo.js